import axiosInstance from '../../../../config/axiosInstance';
const handleSubmitForCheckbox = async (ClientID, checkboxState, redirectCallback, redirectAssignModules) => {
    // Perform validation if needed
    try {
        const formData = { checkboxState, ClientID: ClientID };
       const response = await axiosInstance.post(`/SuperAdmin/AssigModulesToCompany`, formData);
       
    } catch (error) {
        console.error('Error saving checkbox data:', error);
    }
};

export default handleSubmitForCheckbox; 